import request from '@/utils/request'

const Api = {
        GetLoginApry: '/Login/GetLoginApry', //获取当前登录安评师信息
        GetList: '/ZhaoPin/GetList', //获取招聘列表
        GetZhaoPin: '/ZhaoPin/Get', // 根据招聘id查询招聘详情信息
        SaveUpdateZP: '/ZhaoPin/SaveOrUpdate', // 添加/修改招聘信息
        DelZhaoPin: '/ZhaoPin/Delete', // 删除招聘信息
        Report: "/ZhaoPin/Report", // 提交举报信息
    }
    // 获取机构招聘列表
export function GetLoginApry() {
    return request({
        url: Api.GetLoginApry,
        method: 'post'
    })
}
// 获取机构招聘列表
//page, apryId, apjgId
export function GetZhaoPinList(data, pageIndex, pageSize) {
    return request({
        url: Api.GetList,
        data: data,
        params: {
            pageIndex,
            pageSize,
        },
        method: 'post'
    })
}
//根据招聘id查询招聘详情信息
export function GetZhaoPin(zpId, apryId) {
    return request({
        url: Api.GetZhaoPin,
        params: {
            id: zpId,
            apryId
        },
        method: "get"
    })
}

// 创建/修改招聘信息
export function SaveUpdateZP(data) {
    return request({
        url: Api.SaveUpdateZP,
        data,
        method: 'post'
    })
}

// 删除招聘信息
export function DelZhaoPin(zpId) {
    return request({
        url: Api.DelZhaoPin,
        params: {
            id: zpId
        },
        method: 'post'
    })
}

// 提交举报信息
export function Report(data) {
    return request({
        url: Api.Report,
        data,
        method: 'post'
    })
}


// WEBPACK FOOTER //
// ./src/api/zhaopin.js